// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"18245591","453":"d5310c16","796":"14d22de8"}[chunkId] + ".chunk.js";
};